import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import getReducersLayout from '../utils/getReducersLayout';
import { IchatMessages, ImessageObject } from '@api/types/chat';

const initialState: IchatMessages = {
  messages: [],
  collapsed: true,
  connected: 0,
};

const chatSlice = createSlice({
  initialState,
  name: 'chat',
  reducers: {
    ...getReducersLayout<IchatMessages>(initialState),
    addMessage(chats, action: PayloadAction<ImessageObject>) {
      chats.messages.push(action.payload);
    },
    likeMessage(
      chats,
      action: PayloadAction<{
        messageId: string;
        userId: string;
      }>
    ) {
      chats.messages[
        chats.messages.findIndex((msg) => msg.id === action.payload.messageId)
      ].likes.push(action.payload.userId);
    },

    unLikeMessage(
      chats,
      action: PayloadAction<{
        messageId: string;
        userId: string;
      }>
    ) {
      const index = chats.messages.findIndex(
        (msg) => msg.id === action.payload.messageId
      );
      chats.messages[index].likes.splice(
        chats.messages[index].likes.indexOf(action.payload.userId),
        1
      );
    },

    /*eslint-disable no-unused-vars */
    collapseChat(chats, _action: PayloadAction<null>) {
      chats.collapsed = !chats.collapsed;
    },
    setNumberOfConnected(
      chats,
      action: PayloadAction<{
        players: number;
      }>
    ) {
      chats.connected = action.payload.players;
    },
  },
});

export const {
  setData,
  resetData,
  addMessage,
  likeMessage,
  unLikeMessage,
  collapseChat,
  setNumberOfConnected,
} = chatSlice.actions;
export default chatSlice;
